import React, { useMemo, useRef } from 'react';
import { Paper, BottomNavigation, BottomNavigationAction, Fab, Tooltip } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export default function MobileNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const { t } = useTranslation();

  const role = useMemo(() => {
    if (auth && auth.profile && auth.profile.uid) {
      const r = auth.profile.usertype;
      if (r === 'admin' || r === 'fleetadmin' || r === 'customer') return 'customer';
      if (r === 'driver') return 'driver';
    }
    return null;
  }, [auth]);

  const tabs = [
    { value: '/', label: t('home') || 'Home' },
    { value: '/bookings', label: t('my_bookings') || 'Trips' },
    { value: '/userwallet', label: t('wallet') || 'Wallet' },
    { value: '/profile', label: t('myaccount') || 'Profile' },
  ];

  const current = (() => {
    const m = tabs.findIndex(t => location.pathname === t.value);
    return m < 0 ? 0 : m;
  })();

  const onFab = () => {
    if (role === 'driver') navigate('/bookings');
    else navigate('/addbookings');
  };

  // Long press alternate action: reverse of primary
  const pressTimer = useRef(null);
  const startPress = () => {
    clearTimeout(pressTimer.current);
    pressTimer.current = setTimeout(() => {
      if (typeof navigator !== 'undefined' && navigator.vibrate) {
        try { navigator.vibrate(10); } catch(e) {}
      }
      if (role === 'driver') navigate('/addbookings');
      else navigate('/bookings');
    }, 550);
  };
  const cancelPress = () => { clearTimeout(pressTimer.current); };

  const fabLabel = role === 'driver' ? (t('my_bookings') || 'My bookings') : (t('book_your_ride_menu') || 'Book a ride');

  const hideOn = ['/login','/dashboard','/settings','/cartypes','/cars','/notifications','/users','/addtowallet','/withdraws','/allreports','/promos','/cancelreasons'];
  const hidden = hideOn.some(p => location.pathname.startsWith(p));
  if (hidden) return null;

  return (
    <>
      <Paper elevation={8} sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, display: { xs: 'block', md: 'none' }, zIndex: 1100, pb: 'env(safe-area-inset-bottom)' }} role="navigation" aria-label="Bottom navigation">
        <BottomNavigation
          showLabels
          value={current}
          onChange={(e, newValue) => {
            const route = tabs[newValue]?.value;
            if (route) navigate(route);
          }}
        >
          {tabs.map((titem) => (
            <BottomNavigationAction key={titem.value} label={titem.label} />
          ))}
        </BottomNavigation>
      </Paper>
      <Tooltip title={`${fabLabel} · ${role==='driver' ? (t('quick_book') || 'Long-press for Book a ride') : (t('my_bookings') || 'Long-press for My bookings')}`} placement="left" enterTouchDelay={0}>
        <Fab
          variant="extended"
          color="primary"
          aria-label={fabLabel}
          onClick={onFab}
          onMouseDown={startPress}
          onMouseUp={cancelPress}
          onMouseLeave={cancelPress}
          onTouchStart={startPress}
          onTouchEnd={cancelPress}
          sx={{ position: 'fixed', bottom: 'calc(64px + env(safe-area-inset-bottom))', right: 16, display: { xs: 'flex', md: 'none' }, zIndex: 1200, textTransform: 'none', px: 2 }}
        >
          {fabLabel}
        </Fab>
      </Tooltip>
    </>
  );
}
